import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import ContainerCard from "../components/global/containerCard";
import Meta from "../components/global/meta";
import Loader from "../components/global/loader";
import { Button } from "@speedoc/design-assets/";
import Input from "../components/global/Input";
import { resetPassword } from "../services/userService";
import { CheckGreen } from "@speedoc/design-assets/build/icons/index.js";
import URI from "urijs";

export default () => {
  const location = useLocation();
  const [wasSubmitted, setWasSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { token, fromAdmin, fromProvider } = new URI(location.pathname + location.search).search(true);
  const [error, setError] = useState(!token ? "Your password token seems invalid" : "");
  const onSubmit = async e => {
    setIsSubmitting(true);
    setError("");
    e.preventDefault();
    const p1 = e.target.password1.value;
    const p2 = e.target.password2.value;
    if (p1 !== p2) {
      setIsSubmitting(false);
      return setError("Passwords do not match");
    }
    try {
      await resetPassword({ token, fromAdmin, fromProvider, password: p1 });
      setWasSubmitted(true);
    } catch (err) {
      setError(err.response ? err.response.data : err.toString());
    } finally {
      setIsSubmitting(false);
    }
  };

  const onBack = () => {
    setWasSubmitted(false);
  };

  return (
    <div id="passwordReset">
      <Meta title="Password reset" seo={{ index: false }} />

      <ContainerCard>
        <div className="subtitle">MY ACCOUNT</div>
        <div className="title">Reset Password</div>
        <div className="resetBg" />
        <div className="content">
          {!wasSubmitted ? (
            <form onSubmit={onSubmit}>
              <div className="request">Please enter a new password</div>
              <Input type="password" name="password1" required placeholder="New password" />
              <Input type="password" name="password2" required placeholder="Repeat password" />
              <div className="guide">
                Choose a strong password. It should contain at least 8 characters — the more characters, the better.
                Consider including a mixture of both uppercase and lowercase letters, numbers and special characters,
                e.g., ! @ # ? ]
              </div>
              <Button disabled={isSubmitting} type="submit">
                {isSubmitting ? <Loader /> : "Confirm"}
              </Button>
            </form>
          ) : (
            <div className="submitted">
              <div className="checkIcon">
                <CheckGreen />
              </div>
              <div className="text1">Password reset successfully.</div>
              <div className="text2">You may now login using your new password.</div>
              <Button onClick={() => onBack()}>Back</Button>
            </div>
          )}
          <p className="error">{error}</p>
        </div>
      </ContainerCard>
    </div>
  );
};
